import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import React, { useContext, useEffect, useRef } from "react"
// import * as wjcCellMaker from "@grapecity/wijmo.grid.cellmaker"
import dayjs from "dayjs"
import CONSTANT from "../../../../constant"
import { タブレット用点呼情報 } from "../../../../service/tablet/TTabletTenko"
import { TWijmoCellTemplateContext } from "../../../../type/wijmoComponents"

import { Button } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import { AppDispatch } from "../../../.."
import {
  selectTenkoTimingPage,
  selectWeatherPage,
} from "../../../../constant/tablet/pages"
import { setAlerts } from "../../../../globalStore/alertStore"
import { RootState } from "../../../../globalStore/rootreducer"
import ZyomuinService from "../../../../service/driver/zyomuinService"
import TenkoService from "../../../../service/truckcontrol/tenko/tenkoService"
import { TenkoHeaderContext, ZyomuinContext } from "../../context/context"
import { CSS_PROPERTY } from "../../cssProperties/tablet"
import KubunService from "../../../../service/master/kubun/kubunService"
import { 区分分類コード } from "../../../../constant/enum/codes"

const TenkoListGrid: React.FC<{
  tenkoList: タブレット用点呼情報[]
  tenkoBi: string | undefined
  fontSize: (typeof CSS_PROPERTY.GRID_FONT_SIZE)[keyof typeof CSS_PROPERTY.GRID_FONT_SIZE]
}> = (props) => {
  const dispatch: AppDispatch = useDispatch()
  const gridRef = useRef<wjrGrid.FlexGrid>(null)
  const history = useHistory()
  const userInfo = useSelector((root: RootState) => root.user.LoginUserInfo)
  const 営業日 = useSelector((root: RootState) => root.date.eigyobiStr)
  const isToday = dayjs(営業日).isSame(dayjs(props.tenkoBi), "date")

  const { set乗務員 } = useContext(ZyomuinContext)
  const { set点呼ヘッダ情報 } = useContext(TenkoHeaderContext)

  const initializedHandler = (grid: wjcGrid.FlexGrid) => {
    grid.hostElement.addEventListener("click", async (e) => {
      const hitTestInfo = grid.hitTest(e.pageX, e.pageY)

      const binding = hitTestInfo.getColumn()?.binding
      switch (binding) {
        case "乗務員ID":
          if (!isToday) return

          const row = hitTestInfo.getRow()
          const 乗務員: タブレット用点呼情報 = row?.dataItem
          try {
            // 乗務員情報を取得
            const 乗務員Res = await new ZyomuinService().get(乗務員.乗務員ID)

            if (乗務員Res?.data) {
              set乗務員(乗務員Res.data)
            }
            // 部所内の当日の点呼情報を取得
            const 点呼ヘッダ情報Res = await new TenkoService().getHeader({
              点呼日: props.tenkoBi ?? 営業日,
              部所コード: userInfo.部所コード,
            })
            if (点呼ヘッダ情報Res?.data != null) {
              const 点呼ヘッダ = 点呼ヘッダ情報Res?.data

              // 共通指示事項が空の場合、ランダムに入力
              if (点呼ヘッダ.共通指示事項1区分ID == null) {
                const 共通指示事項ListRes = await new KubunService().getList({
                  分類コード: 区分分類コード.運行管理_勤怠.共通指示事項区分,
                })
                const 共通指示事項List = 共通指示事項ListRes?.data ?? []

                let 共通指示事項index = Math.trunc(
                  共通指示事項List.length * Math.random()
                )
                共通指示事項index =
                  共通指示事項index !== 0 ? 共通指示事項index - 1 : 0

                const 共通指示事項1 = 共通指示事項List[共通指示事項index]
                点呼ヘッダ.共通指示事項1区分名称1 = 共通指示事項1.名称1
                点呼ヘッダ.共通指示事項1区分ID = 共通指示事項1.区分ID
                点呼ヘッダ.共通指示事項1区分コード = 共通指示事項1.区分コード
                点呼ヘッダ.共通指示事項1テキスト = 共通指示事項1.名称1
                点呼ヘッダ.共通指示事項2テキスト = 共通指示事項1.名称2
              }

              set点呼ヘッダ情報(点呼ヘッダ情報Res?.data)
              // 点呼情報選択に移行
              history.push(selectTenkoTimingPage.Route.path)
            } else {
              // ヘッダ情報がない場合作成するために天候選択画面に遷移ずる
              history.push(selectWeatherPage.Route.path)
            }
          } catch (error) {
            dispatch(setAlerts(error))
          }
          break
        default:
          break
      }
    })
  }

  useEffect(() => {
    if (
      gridRef == null ||
      gridRef.current == null ||
      gridRef.current.control == null ||
      props.tenkoList == null
    )
      return
    const grid = gridRef.current.control as wjcGrid.FlexGrid

    grid.itemsSource = props.tenkoList.map((tenko) => ({
      ...tenko,
      積日: tenko.積日 && dayjs(tenko.積日).format("MM/DD"),
      卸日: tenko.卸日 && dayjs(tenko.卸日).format("MM/DD"),
    }))
    grid.autoSizeColumns(1)
  }, [props.tenkoList])

  useEffect(() => {
    if (
      gridRef == null ||
      gridRef.current == null ||
      gridRef.current.control == null ||
      props.fontSize == null
    )
      return
    const grid = gridRef.current.control as wjcGrid.FlexGrid
    //ボタンは無視して幅調整
    grid.autoSizeColumns(1)
    grid.refresh()
  }, [props.fontSize])

  return (
    <>
      <wjrGrid.FlexGrid
        {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
        frozenColumns={4}
        className="h-100"
        isReadOnly={true}
        style={
          {
            maxHeight: "25rem",
            fontSize: props.fontSize,
          } as React.CSSProperties
        }
        ref={gridRef}
        initialized={initializedHandler}>
        <wjrGrid.FlexGridColumn
          header=" "
          allowMerging="true"
          binding={"乗務員ID"}
          visible={isToday}
          align="center"
          cssClassAll={"read-only-cell"}
          isReadOnly={true}
          width={90}>
          <wjrGrid.FlexGridCellTemplate
            cellType={wjrGrid.CellTemplateType.Cell}
            template={(
              context: TWijmoCellTemplateContext<タブレット用点呼情報>
            ) => {
              return (
                <Button
                  className="btn btn-small btn-primary move-edit-page"
                  style={{
                    fontSize: "2rem",
                    height: "fit-content",
                  }}>
                  点呼
                </Button>
              )
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="社員コード"
          width={60}
          cssClassAll={"read-only-cell"}
          isReadOnly={true}
          header="社員No"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="社員氏名"
          width={300}
          cssClassAll={"read-only-cell"}
          isReadOnly={true}
          header="乗務員"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="運行数"
          cssClassAll={"read-only-cell"}
          width={40}
          isReadOnly={true}
          header="運行"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="車番"
          width={80}
          cssClassAll={"read-only-cell"}
          isReadOnly={true}
          header="車番"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="トレーラ車番"
          width={80}
          cssClassAll={"read-only-cell"}
          isReadOnly={true}
          header="トレーラ"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="荷主名"
          width={120}
          cssClassAll={"read-only-cell"}
          isReadOnly={true}
          header="荷主名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="積地市区町村"
          width={120}
          cssClassAll={"read-only-cell"}
          isReadOnly={true}
          header="積地"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="卸地市区町村"
          width={120}
          cssClassAll={"read-only-cell"}
          isReadOnly={true}
          header="卸地"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="積日"
          width={80}
          cssClassAll={"read-only-cell"}
          isReadOnly={true}
          header="積日"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="卸日"
          width={80}
          cssClassAll={"read-only-cell"}
          isReadOnly={true}
          header="卸日"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="始業点呼結果フラグ"
          width={60}
          cssClassAll={"read-only-cell"}
          isReadOnly={true}
          header="始業">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={点呼表示Template("始業点呼結果フラグ")}
            cssClassAll={"read-only-cell"}
            isReadOnly={true}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="中間点呼結果フラグ"
          width={60}
          cssClassAll={"read-only-cell"}
          isReadOnly={true}
          header="中間1">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={点呼表示Template("中間点呼結果フラグ")}
            cssClassAll={"read-only-cell"}
            isReadOnly={true}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="終業点呼結果フラグ"
          width={60}
          cssClassAll={"read-only-cell"}
          isReadOnly={true}
          header="終業">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            cssClassAll={"read-only-cell"}
            isReadOnly={true}
            template={点呼表示Template("終業点呼結果フラグ")}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="中間２点呼結果フラグ"
          width={60}
          cssClassAll={"read-only-cell"}
          isReadOnly={true}
          header="中間2">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            cssClassAll={"read-only-cell"}
            isReadOnly={true}
            template={点呼表示Template("中間２点呼結果フラグ")}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="中間３点呼結果フラグ"
          width={60}
          cssClassAll={"read-only-cell"}
          isReadOnly={true}
          header="中間3">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            cssClassAll={"read-only-cell"}
            isReadOnly={true}
            template={点呼表示Template("中間３点呼結果フラグ")}
          />
        </wjrGrid.FlexGridColumn>

        <wjrGrid.FlexGridColumn
          binding="始業２点呼結果フラグ"
          width={60}
          cssClassAll={"read-only-cell"}
          isReadOnly={true}
          header="始業２">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={点呼表示Template("始業２点呼結果フラグ")}
            cssClassAll={"read-only-cell"}
            isReadOnly={true}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="終業２点呼結果フラグ"
          width={60}
          cssClassAll={"read-only-cell"}
          isReadOnly={true}
          header="終業２">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            cssClassAll={"read-only-cell"}
            isReadOnly={true}
            template={点呼表示Template("終業２点呼結果フラグ")}
          />
        </wjrGrid.FlexGridColumn>
      </wjrGrid.FlexGrid>
    </>
  )
}

const 点呼表示Template =
  (propertyName: keyof タブレット用点呼情報) =>
  (context: TWijmoCellTemplateContext<タブレット用点呼情報>) => {
    return context.item[propertyName] === 0 ? (
      <>○</>
    ) : context.item[propertyName] === 1 ? (
      <>×</>
    ) : (
      <></>
    )
  }

export default TenkoListGrid
